import React, { PureComponent } from 'react';

import './no-match-404.scss';

class NoMatch404 extends PureComponent {
  render() {
    return (
      <div className="noMatch404">
        <h2>404 - Page not found</h2>
      </div>
    );
  }
}

export default NoMatch404;
